import { GET_TEAM, UPDATE_TEAM_MEMBER } from '../actions/team';

const initialState = {
  teamData: [],
  teamTotalPage: 1,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_TEAM.SUCCESS: {
      return {
        ...state,
        teamData: payload.data.data.response,
        teamTotalPage: payload.data.data._meta.pageCount,
      };
    }
    case UPDATE_TEAM_MEMBER.SUCCESS: {
      return {
        ...state,
        teamData: state.teamData.map((team) => (team.id === payload.data.userData.id ? payload.data.userData : team)),
      };
    }

    default:
      return state;
  }
};

export default reducer;
